// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tab_tabs___kCch","tab":"Tab_tab__SIQVT","selected":"Tab_selected__T3Jw3","active":"Tab_active__y8c4_","fullWidth":"Tab_fullWidth__6cH7e"};